<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-sheet
      class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16 px-3 mx-auto"
      max-width="500px"
    >
      <div
        class="
          primary--text
          text-subtitle-1 text-md-h6 text-center
          font-weight-medium
          mb-4
        "
      >
        Receba nossa proposta de matrícula:
      </div>

      <RegistryForm v-bind="form" />
    </v-sheet>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import RegistryForm from "../components/forms/RegistryForm.vue";

const _form = {
  action: "/rest/email/registry",
  responseTo: "/matricula/obrigado",
};

const _data = {
  title: "Matrícula",
  form: _form,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    TitleWidget,
    RegistryForm,
  },
};
</script>
